module.exports = __webpack_public_path__ + "static/media/downDarkGray.1f6cf5f7.png";